// extracted by mini-css-extract-plugin
export default {"badge":"ErrorCountBadge_badge__fC3Yl","empty":"ErrorCountBadge_empty__7X1Hc"};